import { useAbility } from '@cast/shared-ability-data-access';

export const useDiscountsAbilities = () => {
  const [canCreate, canEdit, canDelete] = useAbility().canMany([
    ['create', 'OrganizationDiscounts'],
    ['update', 'OrganizationDiscounts'],
    ['delete', 'OrganizationDiscounts'],
  ]);

  return { canCreate, canEdit, canDelete };
};
